import { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL;

interface DashboardStats {
  pending: number;
  approved: number;
  rejected: number;
}

export function useDashboardStats(companyId: string) {
  const [data, setData] = useState<DashboardStats | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!companyId) return;

    const fetchStats = async () => {
      setLoading(true);
      setError(null);

      try {
        const res = await fetch(
          `${API_URL}/documents/stats?companyId=${companyId}`,
          { credentials: "include" }
        );

        if (!res.ok) {
          throw new Error("Failed to load stats");
        }

        const json = await res.json();
        setData(json);
      } catch {
        setError("Nie udało się pobrać statystyk");
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, [companyId]);

  return { data, loading, error };
}
